export default from './Picture';



// WEBPACK FOOTER //
// ./src/containers/Picture/index.js